<template>
  <div>
    <DocumentationHeader />
    <div class="notification flex items-center justify-center w-full">
      <span class="font-neue uppercase"> Espacio para desarrolladores </span>
    </div>
    <router-view />
  </div>
</template>

<script>
import DocumentationHeader from "@/components/DocumentationComponents/DocumentationHead";
export default {
  name: "Root",
  components: {
    DocumentationHeader,
  },
};
</script>
<style lang="scss" scoped>
.notification {
  background-color: #474D59;
  color: white;
  min-height: 38.4px;
}
</style>
